export default __webpack_public_path__ + "static/media/welcome.29faa02f.jpg";